<template>
    <el-card class="box-card" style="width: 1300px;margin:80px auto 0;">
        培训日志
   
    </el-card>
</template>



<script>
export default {
    data() {
        return {
           keys:"",
        }
    },
    methods:{

    init() {
     this.$http
        .post("Exam/GetSearchList", {
         keys: this.keys,
         pageIndex: 1,
         pageSize: 20,
         action: "getExamPracticelog",
        })
        .then((res) => {
          if (res.data.isok) {
            
              
          }
        })
        .catch((err) => {})
    },
  

    },
    created(){
        //  this.id = this.$route.query.id
         this.init()
    }
}



</script>





<style scoped>
 
 
</style>


// WEBPACK FOOTER //
// src/components/Practicelog.vue